"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const uuid_1 = require("./utils/uuid");
class SocketIoSignaling {
    constructor(address, room) {
        this.address = address;
        this.room = room;
        this.id = uuid_1.uuid();
    }
    prepare() {
        this.socket = socket_io_client_1.default(this.address);
        this.socket.on('webrtc', (message) => {
            const socketData = JSON.parse(message).data;
            if (this.onIncomingDataCallback) {
                this.onIncomingDataCallback(socketData);
            }
        });
        this.socket.on('new', (remoteId) => {
            if (this.onInitiateOfferCallback) {
                this.onInitiateOfferCallback(remoteId);
            }
        });
        const socket = this.socket;
        const id = this.id;
        const room = this.room;
        return new Promise(resolve => {
            socket.on('connect', () => {
                resolve();
                socket.emit('room', JSON.stringify({ id: id, room: room }));
            });
        });
    }
    send(to, data) {
        if (!this.socket) {
            return;
        }
        this.socket.emit('webrtc', JSON.stringify({ id: data.id, to: to, data: data }));
    }
    bindOnIncomingDataCallback(callback) {
        this.onIncomingDataCallback = callback;
    }
    bindInitiateOfferCallback(callback) {
        this.onInitiateOfferCallback = callback;
    }
    bindOnWebRtcConnectionErrorCallback(callback) {
        this.onWebRtcConnectionErrorCallback = callback;
    }
    getId() {
        return this.id;
    }
    onWebRtcConnectionError(id) {
        if (this.onWebRtcConnectionErrorCallback) {
            this.onWebRtcConnectionErrorCallback(id);
        }
    }
    disconnect() {
        if (!this.socket) {
            return;
        }
        this.socket.disconnect();
    }
}
exports.SocketIoSignaling = SocketIoSignaling;
